export enum TipoAvaliacao {
  PREPARA_EAD = 'PREPARA_EAD',
  EXERCICIOS = 'EXERCICIOS',
  SIMULADO = 'SIMULADO',
  AVALIACAO = 'AVALIACAO',
}
